<mat-toolbar [color]="color" class="toolbar">
	<ng-content></ng-content>
</mat-toolbar>
